import React from 'react';

interface CustomIconTableDispatchProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconTableDispatch({ height, width, ...props }: CustomIconTableDispatchProps) {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4 8.2666V11.4666H7V8.2666H4Z" fill="currentColor" />
      <path opacity="0.25" d="M4 16.8V20H7V16.8H4Z" fill="currentColor" />
      <path opacity="0.5" d="M4 4V7.2H7V4H4Z" fill="currentColor" />
      <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M8 7.2V4H13V7.2H8Z" fill="currentColor" />
      <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M14 7.2V4H20V7.2H14Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6 11.4666C14.7163 11.4666 14 10.7502 14 9.8666C14 8.9829 14.7163 8.2666 15.6 8.2666H18.4C19.2837 8.2666 20 8.9829 20 9.8666C20 10.7502 19.2837 11.4666 18.4 11.4666H15.6Z"
        fill="currentColor"
      />
      <path
        opacity="0.85"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6 11.4666C14.7163 11.4666 14 10.7502 14 9.8666C14 8.9829 14.7163 8.2666 15.6 8.2666H17V11.4666H15.6Z"
        fill="currentColor"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M8 11.4666V8.2666H13V11.4666H8Z" fill="currentColor" />
      <path
        opacity="0.6"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15.7334V12.5334H20V15.7334H8Z"
        fill="currentColor"
      />
      <path
        opacity="0.6"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0667 15.7334C14.4776 15.7334 14 15.2558 14 14.6667C14 14.0776 14.4776 13.6001 15.0667 13.6001H18.9333C19.5224 13.6001 20 14.0776 20 14.6667C20 15.2558 19.5224 15.7334 18.9333 15.7334H15.0667Z"
        fill="currentColor"
      />
      <path
        opacity="0.25"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6 20C14.7163 20 14 19.2837 14 18.4C14 17.5163 14.7163 16.8 15.6 16.8H18.4C19.2837 16.8 20 17.5163 20 18.4C20 19.2837 19.2837 20 18.4 20H15.6Z"
        fill="currentColor"
      />
      <path
        opacity="0.35"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6 20C14.7163 20 14 19.2837 14 18.4C14 17.5163 14.7163 16.8 15.6 16.8H18V20H15.6Z"
        fill="currentColor"
      />
      <path opacity="0.25" fillRule="evenodd" clipRule="evenodd" d="M8 20V16.8H13V20H8Z" fill="currentColor" />
      <path opacity="0.5" d="M4 12.5334V15.7334H7V12.5334H4Z" fill="currentColor" />
    </svg>
  );
}
